var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bb-sort-by" }, [
    _c(
      "div",
      {
        staticClass: "bb-sort-by-text",
        on: {
          click: function ($event) {
            _vm.show = !_vm.show
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.sort_by) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        staticClass: "bb-sort-by-options",
      },
      [
        _c(
          "div",
          {
            staticClass: "bb-sort-by-option",
            on: {
              click: function ($event) {
                return _vm.sortBy("Best Selling")
              },
            },
          },
          [_vm._v("\n      Best Selling\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "bb-sort-by-option",
            on: {
              click: function ($event) {
                return _vm.sortBy("Alphabetically, A-Z")
              },
            },
          },
          [_vm._v("\n      Alphabetically, A-Z\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "bb-sort-by-option",
            on: {
              click: function ($event) {
                return _vm.sortBy("Alphabetically, Z-A")
              },
            },
          },
          [_vm._v("\n      Alphabetically, Z-A\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "bb-sort-by-option",
            on: {
              click: function ($event) {
                return _vm.sortBy("Price, low to high")
              },
            },
          },
          [_vm._v("\n      Price, low to high\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "bb-sort-by-option",
            on: {
              click: function ($event) {
                return _vm.sortBy("Price, high to low")
              },
            },
          },
          [_vm._v("\n      Price, high to low\n    ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }